module.exports = __webpack_public_path__ + "static/media/personal_online_garage.d373a78d.png";